export default __webpack_public_path__ + "static/media/0294.aeb147fe.jpg";